module.exports = __webpack_public_path__ + "sx4-d5d12145.png";